import { TRawPacketList, useGetRawPackets } from 'api/packets/getRawPacketList'
import { QueryPaginated } from 'components/common'
import { useTranslation } from 'react-i18next'
import { TbList } from 'react-icons/tb'
import { useParams } from 'react-router-dom'
import { MqttPacketTable } from './MqttPacketTable'

export const MqttDevicePacketList = () => {
  const { t } = useTranslation()
  const { deviceId } = useParams()
  const query = useGetRawPackets({ deviceId })

  return (
    <QueryPaginated.Wrapper query={query}>
      <QueryPaginated.Data>
        {(data: TRawPacketList) => (
          <MqttPacketTable
            refetch={query.refetch}
            dataUpdatedAt={query.dataUpdatedAt}
            data={data.items}
            isFetching={query.isFetching}
          />
        )}
      </QueryPaginated.Data>
      <QueryPaginated.NoData icon={TbList} title={t('packet.noData')} />
    </QueryPaginated.Wrapper>
  )
}
